import {useCallback} from 'react';
import {useAppDispatch} from 'store/hooks';
import type {AdvancedSearchViewModeState} from '../types';
import {advancedSearchViewModeUpdated} from '../reducer';

export const useSetAdvancedSearchViewMode = () => {
  const dispatch = useAppDispatch();
  return useCallback(
    (advancedSearchResponseType: AdvancedSearchViewModeState) => {
      dispatch(advancedSearchViewModeUpdated(advancedSearchResponseType));
    },
    [dispatch],
  );
};
